/*
 * Created Date: 16-01-2024, 10:20:57 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Fri Mar 15 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import React from 'react'
import { ROUTER_WORKSPACE_TEAM } from './const'
const LazyMember = React.lazy(() => import('../../System/pages/Setting/Member'))
const LazyRole = React.lazy(() => import('../Role'))
const LazyStudent = React.lazy(() => import('../Student'))

export const workspaceTeamRouterConfig = {
	auth: ['admin'],
	settings: {
		layout: {
			config: {
				sidebar: {
					display: true
				},
				header: {
					display: true
				},
				mobileHeader: {
					display: true
				}
			}
		}
	},
	routes: [
		{
			path: ROUTER_WORKSPACE_TEAM.member_list,

			element: <LazyMember />
		},
		{
			path: ROUTER_WORKSPACE_TEAM.member_role,
			element: <LazyRole />
		},
		{
			path: ROUTER_WORKSPACE_TEAM.student,
			element: <LazyStudent />
		}
	]
}
